module.exports = __webpack_public_path__ + "static/media/avatar-28.9e9fa350.svg";